import { PageType } from "../types/core";
import { isMac } from "./app";
import { AnalyticsProps, trackEvent } from "./analyticsClient";

type Event = "flyover_theater_opened"
    | "flyover_theater_opened_dispatch"
    | "billing_method_started"
    | "billing_method_completed"
    | "blocked_gain_5_min"
    | "blocked_logout"
    | "reactivation_reactivate"
    | "reactivation_logout"
    | "billing_deactivate_click"
    | "billing_deactivate_confirmed"
    | "billing_deactivate_password_confirmed"
    | "billing_deactivate_password_cancelled"
    | "billing_deactivate_questionnaire_submitted"
    | "billing_deactivate_reason"
    | "billing_deactivate_help_taken"
    | "billing_deactivate_continue"
    | "billing_deactivate_kept"
    | "billing_method_exit"
    | "billing_method_submit_click"
    | "billing_method_submit_error"
    | "billing_method_submit_success"
    | "activation"
    | "password_recovery"
    | "routing_calc"
    | "routing_optimize"
    | "routing_undo"
    | "routing_multi"
    | "routing_solve"
    | "routing_better_preview"
    | "routing_better_applied"
    | "routing_better_kept"
    | "routing_day_hours_set"
    | "routing_stop_unassigned"
    | "upgrade_back"
    | "upgrade_logout"
    | "company_setup_logout"
    | "upgrade_success"
    | "upsell_view"
    | "upsell_door"
    | "upsell_billing"
    | "upsell_film"
    | "first_phone_view"
    | "first_phone_share"
    | "first_phone_own"
    | "first_phone_on_map"
    | "first_phone_close"
    | "first_phone_next"
    | "empty_view"
    | "empty_action"
    | "setup_view"
    | "setup_step_view"
    | "setup_step_action"
    | "setup_step_done"
    | "setup_step_skip"
    | "setup_work"
    | "setup_kit"
    | "setup_own_phone_job"
    | "setup_close"
    | "trial_chip"
    | "trial_banner"
    | "trial_banner_choose"
    | "trial_chooser"
    | "trial_chooser_start"
    | "setup_film_open"
    | "help_film_open"
    | "schedule_demo_view"
    | "schedule_demo_time_selected"
    | "schedule_demo_complete"
    | "demo_view"
    | "demo_start"
    | "demo_ready"
    | "demo_failed"
    | "demo_slow"
    | "demo_signup_click"
    | "demo_feedback_open"
    | "demo_feedback_submit"
    | "demo_feedback_skip"
    | "demo_conversion_cta"
    | "demo_conversion_modal_open"
    | "demo_conversion_start_trial"
    | "demo_conversion_continue"
    | "map_provider"
    | "continue_with_google_click"
    | "login_signup_click"
    | "signup_account_view"
    | "signup_account_submit"
    | "signup_account_created"
    | "signup_email_taken"
    | "signup_video_play"
    | "companysetup_code_ok"
    | "companysetup_code_wrong"
    | "companysetup_code_resend"
    | "tailor_card_saved"
    | "tailor_card_dismissed"
    | "continue_with_google_signup"
    | "continue_with_google_login"
    | "continue_with_google_unknown"
    | "continue_with_google_failed"
    | "google_places_predictions"
    | "google_places_details"
    | "google_places_find"
    | "email_verification_logout"
    | "find_assignee_open"
    | "matchai_suggestions_on"
    | "matchai_suggestions_off"
    | "matchai_first_click"
    | "matchai_second_click"
    | "matchai_third_click"
    | "matchai_chip_open"
    | "matchai_chip_first_click"
    | "matchai_chip_second_click"
    | "matchai_chip_third_click"
    | "matchai_check_open"
    | "matchai_how_we_rank_open"
    | "matchai_check_reassign"
    | "matchai_check_keep"
    | "matchai_form_pick"
    | "matchai_form_skill"
    | "skills_twin_used"
    | "skills_template_backfill"
    | "skills_member_proposal_added"
    | "skills_bulk_added"
    | "skills_bulk_removed"
    | "skills_window_open"
    | "skills_window_member_added"
    | "skills_window_member_removed"
    | "skills_window_all_removed"
    | "skills_window_candidate_added"
    | "skills_window_renamed"
    | "skills_window_merged"
    | "skills_window_deleted"
    | "skills_kept_member_has"
    | "skills_kept_job_does_not_need"
    | "skills_kept_skipped"
    | "skills_codispatch_skill_added"
    | "skills_rejection_open"
    | "skills_rejection_reassign"
    | "skills_rejection_skill_added"
    | "find_assignee_assign"
    | "job_card_floating"
    | "job_card_modal"
    | "job_card_sheet"
    | "job_sheet_step"
    | "job_sheet_edit"
    | "job_sheet_field"
    | "job_sheet_undo"
    | "job_sheet_move"
    | "job_sheet_reassign"
    | "job_sheet_status"
    | "job_sheet_message"
    | "job_opened"
    | "job_created"
    | "job_saved"
    | "job_deleted"
    | "job_archived"
    | "job_restored"
    | "job_cloned"
    | "job_sheet_action"
    | "job_sheet_follow"
    | "job_sheet_hint"
    | "routing_better_hint"
    | "job_drop_target"
    | "people_list"
    | "people_rail"
    | "job_bulk_edit"
    | "job_bulk_delete"
    | "job_bulk_archive"
    | "job_bulk_restore"
    | "job_assigned"
    | "job_unassigned"
    | "job_dnd_unassign"
    | "job_dnd_pin"
    | "job_dnd_assign_from_unassigned"
    | "job_dnd_multi_unassign"
    | "job_dnd_multi_other_member"
    | "job_dnd_reorder_same_member"
    | "job_dnd_from_unassigned_to_member"
    | "job_dnd_from_member_to_unassigned"
    | "job_dnd_from_member_to_member"
    | "job_pin"
    | "member_pin"
    | "member_unpin"
    | "sequence_updated"
    | "sequence_dnd_reorder"
    | "sequence_dnd_copy_job"
    | "timecontrol_toggle"
    | "export_jobs_table"
    | "export_location_table"
    | "location_pending_review_scope"
    | "location_view_day"
    | "location_view_trips"
    | "location_trips_show_all"
    | "location_trips_show_stops"
    | "location_trips_show_trips"
    | "location_view_field"
    | "location_field_open_person"
    | "location_field_focus"
    | "location_field_team"
    | "location_day_scrub"
    | "location_day_stop_click"
    | "location_day_drive_open"
    | "location_day_open_job"
    | "location_day_open_place"
    | "location_day_check_phone"
    | "location_replay_menu"
    | "track_editor_create"
    | "track_editor_edit"
    | "session_billing_status"
    | "session_maptype"
    | "gps_quality_check"
    | "export_job_images"
    | "flyover_clip_queued_from_table"
    | "replay_saved_instant"
    | "replay_video_requested"
    | "replay_played_live"
    | "autopilot_decision_applied"
    | "autopilot_decision_rejected"
    | "autopilot_decision_undone"
    | "autopilot_schedule_applied"
    | "autopilot_policy_saved"
    | "autopilot_autonomy_changed"
    | "autopilot_intake_submitted"
    | "autopilot_goal_submitted"
    | "autopilot_goal_applied"
    | "autopilot_goal_stale"
    | "autopilot_goal_rechecked"
    | "autopilot_goal_kept"
    | "autopilot_goal_undone"
    | "autopilot_goal_dismissed"
    | "autopilot_goal_answered"
    | "autopilot_goal_preview_opened"
    | "autopilot_intake_confirmed"
    | "autopilot_intake_undone"
    | "autopilot_intake_dismissed"
    | "autopilot_feed_opened"
    | "autopilot_panel_toggled"
    | "autopilot_pill_seen"
    | "autopilot_turn_on_asked"
    | "autopilot_hint"
    | "autopilot_activated"
    | "autopilot_deactivated"
    | "autopilot_llm_accepted"
    | "autopilot_llm_revoked"
    | "autopilot_voice_transcribed"
    | "autopilot_photo_attached"
    | "autopilot_ask_opened"
    | "autopilot_ask_example"
    | "autopilot_report_open"
    | "autopilot_report_download"
    | "autopilot_report_scheduled"
    | "planner_opened"
    | "planner_week_changed"
    | "planner_workers_changed"
    | "planner_dnd_assign"
    | "planner_dnd_unassign"
    | "planner_dnd_reorder"
    | "planner_ghost_materialized"
    | "planner_week_plan_run"
    | "planner_week_plan_confirmed"
    | "pocket_setup_shown"
    | "pocket_setup_dismissed"
    | "pocket_invite_shared"
    | "pocket_invite_copied"
    | "pocket_get_app"
    | "pocket_first_member"
    | "pocket_fix_sent"
    | "pocket_invite_resent"
    | "pocket_billing_shown"
    | "pocket_billing_card"
    | "pocket_billing_reactivate"
    | "pocket_invite_contacts"
    | "pocket_invite_person"
    | "pocket_invite_profile"
    | "pocket_invite_qr"
    | "pocket_invite_resent_one"
    | "pocket_desktop_switch"
    | "report_run"
    | "report_file_opened"
    | "report_file_shared"
    | "report_schedule_created"
    | "report_schedule_paused"
    | "report_schedule_resumed"
    ;


export function analyticsEvent(event: Event, data = "") {
    sendEvent(event + (data ? ":" + data : ""), { name: event, props: data ? { data } : undefined });
}

export type ReportingAction = "home" | "open" | "preview" | "preview_changed" | "download" | "file_opened"
    | "schedule_open" | "saved" | "retry" | "resume" | "pause" | "delete" | "beta" | "classic_open" | "switch_open" | "switch" | "keep_classic" | "tab" | "new_menu"
    | "columns_open" | "columns" | "column_set_saved";

/** The new reports: which ones people open, try, download, schedule, and how classic schedules move over. */
export function analyticsReporting(action: ReportingAction, props: AnalyticsProps = {}) {
    sendEvent("reporting_" + action, { name: "reporting_" + action, props });
}

/** Which filters people use and where, so the most used ones can become quick filters. */
export function analyticsFilterUsed(scope: string, filter: string, action: "pick" | "clear" | "view") {
    sendEvent("filter_used", { name: "filter_used", props: { scope, filter, action } });
}

export function analyticsCompanySetup(step: number | string) {
    sendEvent("companysetup_" + step);
}

export function analyticsImport(type: string | undefined, action: string) {
    sendEvent("import_" + type + "_" + action);
}

export function analyticsCreateMenu(item: string) {
    sendEvent("create_menu_" + item + "_click");
}

/** The Create menu opened. */
export function analyticsCreateOpen() {
    sendEvent("create_open", { name: "create_open", props: { via: "button" } });
}

export function analyticsAccountMenu(item: string) {
    sendEvent("account_menu_" + item + "_click");
}

export function analyticsNewJobMenu(item: string) {
    sendEvent("newjob_menu_" + item + "_click");
}

export type NewJobEntry = "create_menu" | "tree_button" | "route_banner" | "member_row" | "hotkey" | "map" | "empty_state" | "setup";
export type NewJobSource = "blank" | "template" | "again" | "place" | "address" | "map";

let newJobOpenedAt = 0;
let newJobSource: NewJobSource | undefined;

/** The "Start from" step opened. Starts the clock for newjob_saved. */
export function analyticsNewJobOpen(entry: NewJobEntry) {
    newJobOpenedAt = Date.now();
    newJobSource = undefined;
    sendEvent("newjob_open", { name: "newjob_open", props: { entry } });
}

export function analyticsNewJobChosen(source: NewJobSource) {
    newJobSource = source;
}

/** A job from New job exists now: right away for templates and Again, after the job modal for blank jobs. */
export function analyticsNewJobSaved() {
    if (!newJobSource || !newJobOpenedAt) {
        return;
    }
    const ms = Date.now() - newJobOpenedAt;
    sendEvent("newjob_saved", { name: "newjob_saved", props: { source: newJobSource, ms } });
    newJobOpenedAt = 0;
    newJobSource = undefined;
}

export function analyticsMemberClick(page: PageType, item: string) {
    sendEvent(page +"_member_" + item + "_click");
}

export function analyticsDispatch(item: string) {
    sendEvent("dispatch_" + item);
}

export function analyticsTempMarker(item: string) {
    sendEvent("tempmarker_" + item);
}

export function analyticsGeocode(item: string) {
    sendEvent("geocode_" + item);
}

export function analyticsTrackAnim(item: string) {
    sendEvent("trackanim_" + item);
}

export function analyticsLayerClick(item: string) {
    sendEvent("layer_" + item + "_click");
}

export function analyticsSessionEnvironment(environment: string, isTrialing: boolean) {
    sendEvent("session_environment_" + (environment + (isTrialing ? "_trialing" : "")));
}

export function analyticsDownloadDesktop(isTrialing: boolean) {
    const platform = isMac() ? "mac" : "windows";
    sendEvent("download_desktop_" + (platform + (isTrialing ? "_trialing" : "")));
}

function isMondayEmbeddedApp() {
    if (typeof window === "undefined") {
        return false;
    }
    const params = new URLSearchParams(window.location.search);
    return window.location.pathname.startsWith("/integrations/monday/job")
        || params.get("source") === "monday_item_view";
}

/**
 * Sends the structured name + props when available, otherwise the plain
 * event string.
 */
function sendEvent(event: string, internal?: { name: string; props?: AnalyticsProps }) {
    if (isMondayEmbeddedApp()) {
        return;
    }
    trackEvent(internal ? internal.name : event, internal?.props);
}
